import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { DARK_SIDEBAR, WHITE } from "../../utils/const";
import { CheckBox } from "@material-ui/icons";

const SelectTable = ({
  showOnlySelectedCounters,
  data,
  headers,
  selectedList,
  handleSelectedList,
}) => {
  const final_data = !showOnlySelectedCounters.value
    ? data
    : data.filter((item) => selectedList.value.indexOf(item.id) > -1);
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead style={{ backgroundColor: DARK_SIDEBAR, color: WHITE }}>
          <TableRow>
            <TableCell style={{ color: WHITE, width: "10px" }} align="center">
              <CheckBox />
            </TableCell>
            <TableCell style={{ color: WHITE }} align="center">
              #
            </TableCell>
            {headers.map((item) => (
              <TableCell style={{ color: WHITE }} align="center">
                {item.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {final_data.map((item, idx) => {
            return (
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }} align="center">
                  <input
                    type={"checkbox"}
                    id={item.id}
                    style={{ width: "18px", height: "18px" }}
                    onChange={handleSelectedList}
                    checked={selectedList.value.indexOf(item.id) > -1}
                  />
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="center">
                  {idx + 1}
                </TableCell>
                {headers.map((value) => (
                  <TableCell align={"center"}>
                    {item[`${value["key"]}`]}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SelectTable;
